import { Link } from "react-router-dom";
import { ArrowRight, Clock, Users, DollarSign } from "lucide-react";
import { EXPERIENCES } from "../lib/data";

const RATES = [
  { label: "First hour", price: "$300", note: "up to 8 guests" },
  { label: "Each additional hour", price: "$250", note: "same up to 8 guests" },
  { label: "Overnight stay", price: "$1,500", note: "flat — cabins for 6" },
  { label: "Extra guest (9–10)", price: "+$50 / hr", note: "per additional guest" },
];

export default function Experiences() {
  return (
    <div data-testid="experiences-page" className="bg-sand">
      <section className="pt-28 pb-16 max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="overline mb-5">Experiences</div>
        <h1 className="font-serif-display font-light text-5xl md:text-6xl lg:text-7xl text-navy leading-[1.02] max-w-4xl">
          Four ways to spend a day on the water.
        </h1>
        <p className="mt-6 text-[color:var(--am-muted)] max-w-2xl leading-relaxed">
          Each charter is private. Each pour is considered. Tell us which shape your
          day should take — we'll set the sails accordingly.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 space-y-20 pb-24">
        {EXPERIENCES.map((exp, i) => (
          <article
            key={exp.slug}
            className={`grid lg:grid-cols-12 gap-10 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
            data-testid={`experience-${exp.slug}`}
          >
            <div className="lg:col-span-7 img-zoom aspect-[4/3] overflow-hidden">
              <img src={exp.image} alt={exp.name} className="w-full h-full object-cover" />
            </div>
            <div className="lg:col-span-5">
              <div className="overline mb-3">0{i + 1} · Experience</div>
              <h2 className="font-serif-display text-4xl lg:text-5xl text-navy leading-tight">{exp.name}</h2>
              <p className="italic text-[color:var(--am-muted)] mt-3">{exp.tagline}</p>
              <div className="hairline my-6" />
              <p className="text-[color:var(--am-muted)] leading-relaxed">{exp.description}</p>
              <div className="mt-8 flex flex-wrap gap-6 text-sm">
                <span className="flex items-center gap-2 text-navy"><Clock size={15} /> {exp.duration}</span>
                <span className="flex items-center gap-2 text-navy"><DollarSign size={15} /> {exp.pricing}</span>
                <span className="flex items-center gap-2 text-navy"><Users size={15} /> up to 10</span>
              </div>
              <Link to="/book" state={{ experience: exp.name }} className="btn-primary mt-8" data-testid={`book-${exp.slug}-button`}>
                Book {exp.name} <ArrowRight size={14} />
              </Link>
            </div>
          </article>
        ))}
      </section>

      <section className="bg-pink-soft py-20">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-12">
          <div className="overline mb-4">Rates</div>
          <h2 className="font-serif-display text-4xl lg:text-5xl text-navy leading-tight max-w-xl">Straightforward pricing.</h2>
          <div className="hairline my-10" />
          <div className="grid md:grid-cols-2 gap-y-8 gap-x-16">
            {RATES.map((r, i) => (
              <div key={i} className="flex items-baseline justify-between border-b border-navy/20 pb-4" data-testid={`rate-${i}`}>
                <div>
                  <div className="font-serif-display text-2xl text-navy leading-tight">{r.label}</div>
                  <div className="text-xs tracking-[0.18em] uppercase text-[color:var(--am-muted)] mt-1">{r.note}</div>
                </div>
                <div className="font-serif-display text-2xl text-navy">{r.price}</div>
              </div>
            ))}
          </div>
          <p className="mt-10 text-sm text-[color:var(--am-muted)] max-w-2xl">
            All rates in USD. Bookings require a 50% deposit. 15% crew gratuity is
            customary and appreciated. Add food & bar packages at checkout.
          </p>
        </div>
      </section>
    </div>
  );
}
